var React = require('react');

function Bookmark12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 0.5C2.44772 0.5 2 0.947715 2 1.5V11.5L6 8.9L10 11.5V1.5C10 0.947715 9.55228 0.5 9 0.5H3Z","fill":"currentColor"}));
}

Bookmark12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Bookmark12;

Bookmark12.default = Bookmark12;
